import { Url } from '@wix/da-url';
import { givableBadgeItemsHash } from '../../../../UserWidgets/MyBadges/Badges/BadgeGifts/givableBadgeItems';

interface Item {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}
export const getItems = (
  t,
  {
    pushBadgeModal,
    pushPointsModal,
    onLlamaBadgeSent,
    onCakeBadgeSent,
    profileOwnerUser,
    profileOwnerUser: { username, userId },
    giveState,
    isOwner,
    canViewAsVisitor,
    viewAsVisitor,
    pushBlockModal,
  }
) => {
  let items: Item[] = [];
  if (!isOwner) {
    items = [
      {
        label: giveState.canBeGivenCore
          ? t!('navigation.subnavigation.giveCore')
          : t!('navigation.subnavigation.hasCore'),
        onClick: () => window.location.assign(Url.giveCoreMembership(username)),
        disabled: !giveState.canBeGivenCore,
      },
      {
        label: t!('navigation.subnavigation.givePoints'),
        onClick: () => {
          pushPointsModal(username, t!('navigation.subnavigation.givePoints'));
        },
      },
      {
        label: giveState.canBeGivenLlama
          ? t!('navigation.subnavigation.giveLlamaBadge')
          : t!('navigation.subnavigation.hasGotLlamaBadge'),
        onClick: () => {
          const badge = givableBadgeItemsHash.llama;
          pushBadgeModal(
            'llama',
            userId,
            t!('widgets.badgesbox.gift.give', { title: badge.title }),
            onLlamaBadgeSent
          );
        },
        disabled: !giveState.canBeGivenLlama,
      },
      {
        label: giveState.canBeGivenCake
          ? t!('navigation.subnavigation.giveCakeBadge')
          : t!('navigation.subnavigation.hasGotCakeBadge'),
        onClick: () => {
          const badge = givableBadgeItemsHash.cake;
          pushBadgeModal(
            'cake',
            userId,
            t!('widgets.badgesbox.gift.give', { title: badge.title }),
            onCakeBadgeSent
          );
        },
        disabled: !giveState.canBeGivenCake,
      },
    ];
  }
  if (canViewAsVisitor && isOwner) {
    items.push({
      label: t('navigation.subnavigation.viewAsVisitor'),
      onClick: viewAsVisitor,
    });
  }

  if (!isOwner) {
    items.push({
      label: t('navigation.subnavigation.blockUser'),
      onClick: () => pushBlockModal(profileOwnerUser),
    });
  }

  return items;
};
